/**
 * Search input component. User input for the search.
 */
import Caret from '@components/atoms/text/searchCaret';
import Container from '@components/atoms/container/searchInputContainer';
import Focus from '@shared/types/enums/focus';
import FocusUtils from '@shared/utils/focus';
import Icon from '@components/atoms/icons/search';
import Input from '@components/atoms/text/searchInput';
import Results from '@components/atoms/text/searchResultsText';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { selectFocus } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Search input component props
 */
interface Props {
  input?: string;
  error: boolean;
  results: number | null;
  searching?: boolean;
  selection?: string;
}

/**
 * Search input component. Rendereed above the search results.
 */
export default function SearchInput({
  error,
  input,
  results,
  selection,
  searching,
}: Props) {
  // Selectors
  const focus = useAppSelector(selectFocus);

  // Constants
  const caret = focus === Focus.SEARCH_KEYBOARD;
  const showInput =
    !FocusUtils.evaluateFocus(Focus.RAILS_LIST) &&
    !FocusUtils.evaluateFocus(Focus.FLOATING_MENU);
  const message =
    results && selection && !error
      ? TranslationManager.get(
          'COMPONENTS.SEARCH.RESULT' + (results > 1 ? 'S' : ''),
          results.toString(),
          selection || ''
        )
      : null;

  // Render
  return showInput ? (
    <Container>
      <Icon />
      <Input>
        {input?.toUpperCase() || ''}
        {caret ? <Caret>{'|'}</Caret> : null}
      </Input>
      <Results
        dangerouslySetInnerHTML={{
          __html: !searching ? message || '' : '',
        }}
      />
    </Container>
  ) : null;
}
